import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0212 from "../lesson-12/lesson";
import lesson0216 from "../lesson-16/lesson";
import lesson0217 from "../lesson-17/lesson";
import lesson0222 from "../lesson-22/lesson";
import lesson0223 from "../lesson-23/lesson";
import lesson0224 from "../lesson-24/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "f02f5136-8de4-44e8-9148-839c7abc5c69",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0212),
    lesson: lesson0212,
  },
  {
    id: "a2e32500-4865-4755-9361-c5c766d8708b",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0216),
    lesson: lesson0216,
  },
  {
    id: "9fe6e13a-63de-4980-a81b-6b2f1f13d1e7",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0217),
    lesson: lesson0217,
  },
  {
    id: "45f664b2-7424-4416-82ca-efd7fdfd534c",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0222),
    lesson: lesson0222,
  },
  {
    id: "fb674860-8c73-4a2b-a32c-af8198f9bfeb",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0223),
    lesson: lesson0223,
  },
  {
    id: "ab7a881f-b372-440e-9f63-2dff1597e991",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0224),
    lesson: lesson0224,
  },
];

export default lessonLinks;
